import { render, staticRenderFns } from "./AssesmentMenu.vue?vue&type=template&id=4e4bcfe6&"
import script from "./AssesmentMenu.vue?vue&type=script&lang=js&"
export * from "./AssesmentMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports